import { LatestTransactionsTableTranslations } from ".";

export const LATEST_TRANSACTIONS_TABLE_ES_MX: LatestTransactionsTableTranslations = {
	title: "Últimos retiros y anticipaciones",
	date: "Fecha de solicitud",
	paymentDate: "Fecha de pago",
	status: "Estado",
	type: "Tipo",
	value: "Valor",
	actions: "Acciones",
	requester: "Solicitante",
	refused: "Rechazado",
	pending: "Pendiente",
	canceled: "Cancelado",
	paid: "Pagado",
	processingCancellation: "Procesando cancelación",
	processing: "Procesando",
	pixProcessing: "Procesando PIX",
	bankslipProcessing: "Procesando Boleto",
	pendingManagerApproval: "Pendiente de aprobación del gerente",
	pendingPlaceConfirmation: "Pendiente de confirmación del place",
	canceledPlaceConfirmation: "Confirmación del place cancelada",
	pendingAnticipation: "Pendiente de anticipación",
	pendingTreasuryAction: "Pendiente de acción de la ZIG",
	prorata: "Pró rata",
	pixKey: "Clave PIX",
	reason: "Motivo",
	requestReason: "Motivo",
	refusalReason: "Motivo del rechazo",
	favorecido: "Beneficiario",
	dataInicial: "Fecha inicial",
	dataFinal: "Fecha final",
	at: "a las",
	contaPropria: "Cuenta propia",
	placeDestino: "Place de destino",
	beneficiarioBoleto: "Beneficiario del boleto",
	back: "Volver",
	withdrawal: "Retiro",
	anticipation: "Anticipación",
	detailsTitle: "Detalles de la transacción",
	filename: "retiros-anticipos-boletos",
	// Nuevos campos para cuenta bancaria
	accountHolder: "Titular de la Cuenta",
	accountType: "Tipo de Cuenta",
	agency: "Sucursal",
	account: "Cuenta",
	bankName: "Nombre del Banco",
	accountName: "Nombre de la Cuenta",
	cancelWithdraw: "Cancelar retiro",
	viewDetails: "Ver detalles",
	cancelConfirmTitle: "Cancelar retiro",
	cancelConfirmDescription:
		"¿Estás seguro de que quieres cancelar este retiro? Esta acción no se puede deshacer.",
	confirmCancel: "Sí, cancelar",
	internalObservation: "Observaciones",
	table: {
		datetime: "Fecha de solicitud",
		paymentDate: "Fecha de pago",
		type: "Tipo",
		status: "Estado",
		username: "Usuario",
		vendor: "Proveedor",
		requestedValue: "Valor solicitado",
		liquidAnticipatedValue: "Valor anticipado",
		proRataFee: "Prorrata",
		appliedFee: "Tasa aplicada",
		proRataFeeTooltip:
			"Tasa de anticipación proporcional al período del saldo a anticipar",
		totalBruteValue: "Valor bruto total",
		bankAccount: "Cuenta bancaria",
		ticketPayment: "Pago con boleto",
		clientObservation: "Motivo",
		obs: "Observación",
		paymentMethod: "Método de pago",
		attachments: "Adjuntos",
		confirmWithdrawBtnLabel: "Confirmar solicitud",
	},
	transactionLink: "Enlace de transacción",
	filterByType: "Filtrar por tipo",
	allTypes: "Todos los tipos",
	typeWithdraw: "Retiro",
	typeAnticipation: "Anticipación",
	typeTicketPayment: "Pago de boleto",
	typeTransferBetweenPlaces: "Transferencia entre Places",
	// Traducciones para retiros rechazados y relacionados
	viewOriginalWithdraw: "Ver retiro original",
	viewNewWithdraw: "Ver nuevo retiro",
	originalWithdrawRequest: "Solicitud Original",
	newWithdrawRequest: "Nueva Solicitud",
	withdrawDeclinedTitle: "Retiro Rechazado por Saldo Insuficiente",
	withdrawDeclinedMessage:
		"Este retiro fue rechazado automáticamente porque el saldo disponible era insuficiente en el momento de la aprobación. Si el valor en cuenta es mayor que R$ 50,00, haremos una nueva solicitud.",
	thisIsNewWithdraw:
		"Este es el nuevo retiro creado después del rechazo del retiro original.",
	thisIsDeclinedWithdraw: "Este retiro fue rechazado y se creó un nuevo retiro.",
	retryPixReceipt: "Generar nuevo comprobante",
	retryPixReceiptSuccess: "¡Comprobante generado con éxito!",
	retryPixReceiptError: "Error al generar nuevo comprobante",
	receiptNotAvailable: "Comprobante no disponible",
};
